import { render, staticRenderFns } from "./addressComp.vue?vue&type=template&id=5b42e5e4&scoped=true&"
import script from "./addressComp.vue?vue&type=script&lang=js&"
export * from "./addressComp.vue?vue&type=script&lang=js&"
import style0 from "./addressComp.vue?vue&type=style&index=0&id=5b42e5e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42e5e4",
  null
  
)

export default component.exports